module.exports = __webpack_public_path__ + "img/ayuntamiento.de862347.png";